<div class="toast-confirmation">
  <div class="toast-confirmation__content">
    <p>{{ data?.message }}</p>
  </div>
  <div class="toast-confirmation__actions" *ngIf="data.enabledActions">
    <button
      mat-button
      color="primary"
      class="toast-confirmation__button"
      (click)="accept()"
    >
      {{ data?.primaryButtonText || 'OK' }}
    </button>
    <button
      mat-icon-button
      color="accent"
      aria-label="Example icon button with a menu icon"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
